import { lazy } from 'react';
/** Открывает карточку подписки */
export const SubscriptionDetailsPageAsync = lazy(() => import('./SubscriptionDetails/SubscriptionDetailsPage'));